import { LiveQueueWOTable } from "./LiveQueueWOTable";

export default LiveQueueWOTable;
